import { useMutation } from '@tanstack/vue-query'
import { createPublicSupportTicket } from '../supportEndpoints'
import { parseCreatedTicketReference } from '../parsers/supportTicketParser'

// Files a ticket from the public contact page. Nothing to invalidate: a
// visitor has no ticket list to refresh.
export function useCreatePublicSupportTicketMutation() {
  return useMutation({
    mutationFn: (request: Parameters<typeof createPublicSupportTicket>[0]) =>
      createPublicSupportTicket(request).then(parseCreatedTicketReference),
  })
}
